export default __webpack_public_path__ + "static/media/personal_file.f20d42bb.jpg";